(function () {
  "use strict";

  a3_cabin_reports.controller("FoundPropertyCtrl", FoundPropertyCtrl);

  /**
   * @memberof CabinReports
   * @ngdoc controller
   * @name FoundPropertyCtrl
   * @description
   *  Manages the Special Modal View
   * @ngInject
   */
  function FoundPropertyCtrl($scope, $uibModalInstance, foundProperty) {
    console.log("MODAL INPUT foundProperty:", angular.copy(foundProperty));

    // Image compression settings
    $scope.quality = 0.4;
    $scope.maxWidth = 1024;
    $scope.maxHeight = 768;

    $scope.categories = [
      "Bag",
      "Book",
      "Camera",
      "Charger / Powerbank",
      "Clothing",
      "Cosmetics",
      "Duty Free",
      "Earphones / Headphones",
      "eBook Reader",
      "Footwear",
      "Glasses / Sunglasses",
      "Headwear",
      "Jewellery",
      "Kids / Infant care",
      "Laptop",
      "Medical Item",
      "Mobile Phone",
      "Other",
      "Passport / ID / Documents",
      "Pillow",
      "Tablet",
      "Toy",
      "Umbrella",
      "Videogames",
      "Wallet",
      "Watch",
    ];

    $scope.seats = ["A", "B", "C", "D", "E", "F"];

    $scope.clearFoundPropertyDescription = function () {
      $scope.foundProperty.DetailedDescription = "";
    };

    $scope.clearFoundPropertyComments = function () {
      $scope.foundProperty.Comments = "";
    };

    $scope.foundProperty = foundProperty || {
      Category: "",
      DetailedDescription: "",
      Images: [],
      SeatRow: "",
      Seat: "",
      Comments: "",
      Signature: [],
      AgentName: "",
    };

    $scope.foundProperty.Photos = $scope.foundProperty.Photos || [];

    /**
     * Resize and compress image
     * @memberof FoundPropertyCtrl
     */
    function resizeAndCompressImage(dataURL, fileType, callback) {
      var img = new Image();
      img.onload = function () {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");

        // Calculate new dimensions while maintaining aspect ratio
        var width = img.width;
        var height = img.height;

        if (width > $scope.maxWidth || height > $scope.maxHeight) {
          var ratio = Math.min(
            $scope.maxWidth / width,
            $scope.maxHeight / height,
          );
          width = Math.floor(width * ratio);
          height = Math.floor(height * ratio);
        }

        canvas.width = width;
        canvas.height = height;

        // Draw and compress
        ctx.drawImage(img, 0, 0, width, height);

        // Convert to compressed base64
        var compressedDataURL = canvas.toDataURL(
          fileType || "image/jpeg",
          $scope.quality,
        );
        var base64Data = compressedDataURL.split(",")[1];

        callback(base64Data, fileType);
      };
      img.src = dataURL;
    }

    $scope.addPhotos = function (files) {
      if (!files || !files.length) return;

      Array.from(files).forEach(function (file) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var result = e.target.result;

          if (!result || !result.includes(",")) {
            return;
          }

          var fileType = file.type || "image/jpeg";

          // Resize and compress the image
          resizeAndCompressImage(
            result,
            fileType,
            function (compressedBase64, finalFileType) {
              $scope.$apply(function () {
                $scope.foundProperty.Images = $scope.foundProperty.Images || [];
                $scope.foundProperty.Images.push({
                  PhotoData: compressedBase64,
                  FileType: finalFileType,
                });
              });
            },
          );
        };
        reader.readAsDataURL(file);
      });
    };

    // Tracks whether user is trying to save as completed (strict validation)
    $scope.submitAttempted = false;

    $scope.onSaveCompletedClick = function () {
      $scope.submitAttempted = true;
      $scope.ok(); // will validate via isFoundPropertyValid()
    };

    $scope.onSaveDraftClick = function () {
      // Draft should NOT trigger required validation UI
      $scope.submitAttempted = false;
      $scope.saveAsDraft();
    };

    $scope.ok = function () {
      $scope.foundProperty.Status = $scope.isFoundPropertyValid()
        ? "completed"
        : "draft";
      $uibModalInstance.close($scope.foundProperty);
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss("cancel");
    };

    $scope.saveAsDraft = function () {
      $scope.foundProperty.Status = "draft";
      $uibModalInstance.close($scope.foundProperty);
    };

    function hasValue(value) {
      return value != null && String(value).trim() !== "";
    }

    $scope.hasAnyValue = function () {
      return (
        hasValue($scope.foundProperty.Category) ||
        hasValue($scope.foundProperty.DetailedDescription) ||
        hasValue($scope.foundProperty.SeatRow) ||
        hasValue($scope.foundProperty.Seat) ||
        hasValue($scope.foundProperty.Comments) ||
        (Array.isArray($scope.foundProperty.Images) &&
          $scope.foundProperty.Images.length > 0) ||
        hasValue($scope.foundProperty.AgentName) ||
        (Array.isArray($scope.foundProperty.Signature) &&
          $scope.foundProperty.Signature.length > 0)
      );
    };

    $scope.isFoundPropertyValid = function () {
      var fp = $scope.foundProperty;

      return (
        hasValue(fp.Category) &&
        hasValue(fp.AgentName) &&
        Array.isArray(fp.Signature) &&
        fp.Signature.length > 0
      );
    };
  }
})();
